import React, { useState, useEffect } from "react";
import "./Overlay.css";
import { FaBell } from 'react-icons/fa';
import config from "../../../config.js";
import ProgressTracker from "../../../views/dashboards/ProgressTracker.js";

const Overlayy = ({ complaint_id }) => {
  const designation = localStorage.getItem('designation');
  const [modal, setModal] = useState(false);
  const [complaint, setComplaint] = useState(null);
  const [notifyEnabled, setNotifyEnabled] = useState(false); 

  const complaintDetails = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/getcomplaint/${complaint_id}`, {
        headers: { "Content-Type": "application/json" },
        method: "GET"
      });
      const jsonData = await response.json();
      setComplaint(jsonData);
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleNotify = async () => {
    try {
      var receiverId = '';
      if (complaint.notify_count < 2) {
        receiverId = complaint.technician_id;
        const notifications = JSON.parse(localStorage.getItem("notifications")) || [];
        var complaintId = complaint_id;

        notifications.push({ receiverId, message: `You have been notified to complete the complaint ${complaintId} as soon as possible` });
        localStorage.setItem("notifications", JSON.stringify(notifications));
        await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ complaintId, receiverId, message: `You have been notified to complete the complaint ${complaintId} as soon as possible` })
        });

        const notify_count = complaint.notify_count + 1;
        const last_notify_date = getCurrentDate();
        await fetch(`${config.BASE_URL_IP}/wob/changeNotifyDetails`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ complaintId, notify_count, last_notify_date })
        });

        window.alert("Notification sent successfully!");

        window.location.reload();
      } else {
        receiverId = 'D01';
        const notifications = JSON.parse(localStorage.getItem("notifications")) || [];
        var complaintId = complaint_id;
        
        notifications.push({ receiverId, message: `You have been notified to complete the complaint ${complaintId} as soon as possible` });
        localStorage.setItem("notifications", JSON.stringify(notifications));

        await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ complaintId, receiverId, message: `The complaint with complaint id - ${complaintId} has not been attended by the Technician ${complaint.technician_id}` })
        });

        const notify_count = complaint.notify_count + 1;
        const last_notify_date = getCurrentDate();
        await fetch(`${config.BASE_URL_IP}/wob/setUnattendedComplaint`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ complaint_id, notify_count, last_notify_date })
        });

        window.alert("Notification sent successfully!");

        window.location.reload();
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const getCurrentDate = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  };

  useEffect(() => {
    complaintDetails();
  }, []);

  useEffect(() => {
    if (complaint) {
      const currentDate = getCurrentDate();
      const workAssignedDate = new Date(complaint.work_assigned_date);
      const expectedCompletionDate = new Date(complaint.expected_completion_date);
      const lastNotifyDate = new Date(complaint.last_notify_date);

      const isNotifyEnabled = (
        (complaint.work_assigned_date && complaint.work_status === 'inProgress' &&
          currentDate > workAssignedDate &&
          currentDate > new Date(lastNotifyDate.setDate(lastNotifyDate.getDate() + 3)) &&
          complaint.notify_count <= 3 &&
          !complaint.work_completion_date) ||
        (complaint.expected_completion_date && complaint.work_status === 'inProgress' &&
          currentDate > expectedCompletionDate &&
          currentDate > new Date(lastNotifyDate.setDate(lastNotifyDate.getDate() + 3)) &&
          complaint.notify_count <= 3 &&
          !complaint.work_completion_date)
      );

      setNotifyEnabled(isNotifyEnabled);
    }
  }, [complaint]);

  if (modal) {
    document.body.classList.add('active-modal');
  } else {
    document.body.classList.remove('active-modal');
  }

  return (
    <>
      <button onClick={toggleModal} className="btn-modal">
        Open
      </button>

      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content">
            <h2>Work Order Details</h2>
                {!complaint.work_order_id && (<p>
                  <strong>Work Order Id:</strong> {complaint_id}
                </p>)}
                {complaint.work_order_id && (<p>
                  <strong>Work Order Id:</strong> {complaint.work_order_id}
                </p>)}
                <p>
                  <strong>Work Order Title:</strong> {complaint.title}
                </p>
                <p>
                  <strong>Work Order Raiser Id:</strong> {complaint.complainer_id}
                </p>
                <p>
                  <strong>Work Order Raiser Name:</strong> {complaint.user_name}
                </p>
                <p>
                  <strong>Department:</strong> {complaint.department}
                </p>
                <p>
                  <strong>Work Order Body:</strong> {complaint.body}
                </p>
                <p>
                  <strong>Work Order Type:</strong> {complaint.complaint_type}
                </p>
                <p>
                  <strong>Sub Work Order Type:</strong> {complaint.sub_complaint_type}
                </p>
                <p>
                  <strong>Venue:</strong> {complaint.venue}
                </p>
                <p>
                  <strong>Work Order Status:</strong> {complaint.work_status}
                </p>
                {complaint.contact_num && (
                <p>
                  <strong>Contact Info:</strong> {complaint.contact_num}
                </p>
                )}
                {complaint.hod_approve_comments && (
                <p>
                  <strong>HOD Approve Comments:</strong> {complaint.hod_approve_comments}
                </p>
                )}
                {complaint.technician_id && (
                  <>
                  <p>
                    <strong>Technician Assigned Id:</strong> {complaint.technician_id}
                  </p>
                  </>
                )}
                {(complaint.completion_summary && (complaint.work_status === 'Completed' || complaint.work_status === 'Completed-Without-Satisfaction-Points')) && (
                <p>
                  <strong>Completion Summary:</strong> {complaint.completion_summary}
                </p>
                )}
                {(complaint.completion_summary && (complaint.work_status === 'Closed-technician') && (designation === 'Supervisor' || designation === 'Technician') ) && (
                <p>
                  <strong>Completion Summary:</strong> {complaint.completion_summary}
                </p>
                )}
                {complaint.satisfaction_points && (
                <p>
                  <strong>Satisfaction Points:</strong> {complaint.satisfaction_points}
                </p>
                )}
                {complaint.justification && (
                <p>
                  <strong>Justification:</strong> {complaint.justification}
                </p>
                )}
                {complaint.rejection_summary && (
                <p>
                  <strong>Rejection Summary:</strong> {complaint.rejection_summary}
                </p>
                )}
            <ProgressTracker complaintId={complaint_id} />

                {designation === 'Complainer' && (
                  <button
                    className={`notify-button ${notifyEnabled ? "enabled" : "disabled"}`}
                    disabled={!notifyEnabled}
                    onClick={handleNotify}
                  >
                    <FaBell /> Notify
                  </button>
                )}
            <button className="close-modal" onClick={toggleModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Overlayy;
